import sc from 'styled-components';

export const Container = sc.div`
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FormInfoWrapper = sc.div`
  p {
    font-size: 1.125rem;
    margin-bottom: 0.75rem;
  }

  em {
    font-size: .875rem;
    color: #2d3748;
  }

  > div {
    display: flex;
    gap: 1rem;

    > span {
      padding-bottom: .25rem;
      border-bottom-width: 1px;
      border-color: #718096;
      border-bottom-style: solid;
      font-size: .875rem;
    }
  }
`;